import isNull from 'lodash/isNull';
import has from 'lodash/has';
import AlertTypeEnum from '@/enums/alertType';

export default {
    props: {
        alertType: {
            type: String,
            default: null,
            validator: v => isNull(v) || has(AlertTypeEnum, v.toUpperCase())
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String,
            default: null
        }
    },
    computed: {
        alertTypeValue() {
            if (!isNull(this.alertType)) {
                return AlertTypeEnum[this.alertType.toUpperCase()];
            }

            return null;
        },
        alertColor() {
            if (!isNull(this.alertTypeValue)) {
                return this.alertTypeValue.color;
            }

            return this.color;
        },
        alertTextColor() {
            if (!isNull(this.alertTypeValue)) {
                return `${this.alertTypeValue.color}--text`;
            }

            return `${this.color}--text`;
        },
        alertIcon() {
            if (!isNull(this.alertTypeValue)) {
                return this.alertTypeValue.icon;
            }

            return this.icon;
        }
    }
};
